import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  type MedicalInfoRequestItem,
  type MedicalInfoRequestStatus,
  medicalInfoRequestStatusOptions,
} from '../../../constants/patient';
import IntakeFormRow from '../IntakeFormRow';
import IntakeTextField from '../IntakeTextField';
import IntakeToggleGroup from '../IntakeToggleGroup';
import { INTAKE_LABEL_WIDTH } from '../intakeFormLayout';

type Props = {
  value: MedicalInfoRequestItem[];
  onChange: (value: MedicalInfoRequestItem[]) => void;
};

const emptyItem = (): MedicalInfoRequestItem => ({
  destination: '',
  status: 'not_requested',
});

/** 診療情報提供書依頼: 依頼先とステータスのペアを複数設定 */
const MedicalInfoRequestFields: React.FC<Props> = ({ value, onChange }) => {
  const updateItem = (index: number, partial: Partial<MedicalInfoRequestItem>) => {
    const next = [...value];
    next[index] = { ...next[index], ...partial };
    onChange(next);
  };

  return (
    <>
      {value.map((item, i) => (
        <IntakeFormRow
          key={i}
          label={i === 0 ? '診療情報提供書依頼' : ''}
          align="flex-start"
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1 }}>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              <IntakeTextField
                placeholder="依頼先"
                value={item.destination}
                onChange={(e) => updateItem(i, { destination: e.target.value })}
                sx={{ flex: 1 }}
              />
              {value.length > 1 && (
                <IconButton
                  size="small"
                  aria-label="削除"
                  onClick={() => onChange(value.filter((_, j) => j !== i))}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
            <IntakeToggleGroup
              options={medicalInfoRequestStatusOptions}
              value={item.status}
              onChange={(v) => updateItem(i, { status: v as MedicalInfoRequestStatus })}
              ariaLabel="依頼ステータス"
            />
          </Box>
        </IntakeFormRow>
      ))}
      {value.length < 20 && (
        <Button
          startIcon={<AddIcon />}
          size="small"
          onClick={() => onChange([...value, emptyItem()])}
          sx={{ ml: INTAKE_LABEL_WIDTH, mb: 0.5 }}
        >
          依頼先を追加
        </Button>
      )}
    </>
  );
};

export default MedicalInfoRequestFields;
